An optional free-text billing reference.

SEEK does not use this field on unposted position profiles.

This field has a maximum length of 50 characters.
